import React from 'react'
import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import PriceRowLuxPlusNonMemberPrice from 'LuxKit/PricePoints/LuxPlus/PriceRowLuxPlusNonMemberPrice'
import PriceRowLuxPlusPrice from 'LuxKit/PricePoints/LuxPlus/PriceRowLuxPlusPrice'
import { getIsEnabledLuxPlusDiscountedExperiences } from 'luxPlus/selectors/featureToggle'
import { connect } from 'react-redux'
import PriceRowValueDiscountWithCaption from 'LuxKit/PricePoints/Value/PriceRowValueDiscountWithCaption'

interface MappedProps {
  isLuxPlusEnabled: boolean
}

interface Props extends MappedProps {
  totalPrice?: number
  totalMemberPrice?: number
  totalGrossPrice?: number
  discountPercentage?: number
  isFromPrice: boolean
  ticketUnitLabel: string
  size?: 'S' | 'L' | 'M'
  nonMemberPriceSize?: 'L' | 'M'
  discountMemberPercentage?: number
}

function ExperienceTilePrices(props: Props) {
  const {
    totalPrice,
    totalMemberPrice,
    totalGrossPrice,
    discountPercentage,
    isFromPrice,
    ticketUnitLabel,
    isLuxPlusEnabled,
    size = 'S',
    nonMemberPriceSize = 'M',
    discountMemberPercentage,
  } = props

  if (isLuxPlusEnabled && totalMemberPrice) {
    return (
      <>
        {isFromPrice && <PriceRowPriceCaption>From</PriceRowPriceCaption>}
        <PriceRowLuxPlusPrice
          logoPlacement="trailing"
          size={size}
          memberPrice={totalMemberPrice}
          saleUnit="total"
        />
        {!!totalPrice && (
          <PriceRowLuxPlusNonMemberPrice
            nonMemberPrice={totalPrice}
          />
        )}
        {!!totalGrossPrice && <PriceRowValueDiscountWithCaption
          originalValue={totalGrossPrice}
          size={nonMemberPriceSize}
          discountPercentage={discountMemberPercentage}
          discountType={isFromPrice ? 'estimate' : 'exact'}
        />}
      </>
    )
  }

  if (!totalPrice) return null

  const shouldShowValueDiscount = !!totalGrossPrice && !!discountPercentage

  return (
    <>
      {isFromPrice && <PriceRowPriceCaption>From</PriceRowPriceCaption>}

      <PriceRowPrice
        size={size}
        price={totalPrice}
        saleUnit={isFromPrice ? ticketUnitLabel : 'total'}
      />
      {shouldShowValueDiscount && <PriceRowValueDiscountWithCaption
        originalValue={totalGrossPrice}
        size={nonMemberPriceSize}
        discountPercentage={discountPercentage}
        discountType={isFromPrice ? 'estimate' : 'exact'}
      />}
    </>
  )
}

function mapStateToProps(state: App.State) {
  return {
    isLuxPlusEnabled: getIsEnabledLuxPlusDiscountedExperiences(state),
  }
}

export default connect(mapStateToProps)(ExperienceTilePrices)
